import React, { Component } from "react";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { UserContext } from "../UserContext";
import SettingsPanel from "./shared/SettingsPanel";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";
import { withRouter3 } from "./withRouter3"; // HOC custom
import PrivateRoute3 from "./PrivateRoute3";
const IDLE_TIMEOUT = 25 * 60 * 1000;
class App2 extends Component {
  static contextType = UserContext; // ✅ pour accéder à this.context.setUser

  state = {
    isFullPageLayout: false,
  };

  timer = null;
  componentDidMount() {
    this.onRouteChanged();
    this.startIdleTimer();
    this.addActivityListeners();
  }

  componentDidUpdate(prevProps) {
    if (this.props.router.location !== prevProps.router.location) {
      this.onRouteChanged();
    }
  }
  componentWillUnmount() {
    this.clearIdleTimer();
    this.removeActivityListeners();
  }
  // ======== Gestion de l’inactivité =========
  startIdleTimer = () => {
    this.clearIdleTimer();
    this.timer = setTimeout(this.logout, IDLE_TIMEOUT);
  };

  clearIdleTimer = () => {
    if (this.timer) clearTimeout(this.timer);
  };

  resetIdleTimer = () => {
    this.startIdleTimer();
  };

  addActivityListeners = () => {
    this.events = [
      "mousemove",
      "mousedown",
      "keypress",
      "touchstart",
      "scroll",
    ];
    this.events.forEach((event) =>
      window.addEventListener(event, this.resetIdleTimer),
    );
  };

  removeActivityListeners = () => {
    this.events.forEach((event) =>
      window.removeEventListener(event, this.resetIdleTimer),
    );
  };

  logout = () => {
    this.context.setUser(null);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_info");
    alert("Vous avez été déconnecté pour cause d'inactivité.");
    this.props.router.navigate("/login"); // redirection vers login
  };

  onRouteChanged() {
    console.log("ROUTE CHANGED");
    const { i18n } = this.props;
    const { location } = this.props.router;

    const body = document.querySelector("body");
    if (location.pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
      i18n.changeLanguage("ar");
    } else {
      body.classList.remove("rtl");
      i18n.changeLanguage("en");
    }

    window.scrollTo(0, 0);

    const fullPageLayoutRoutes = [
      "/clogin",
      "/menp",
      "/empc",
      "/fentb",
      "/user-pages/login-1",
      "/user-pages/register-1",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
      "/dipl",
    ];

    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (location.pathname === fullPageLayoutRoutes[i]) {
        this.setState({ isFullPageLayout: true });
        document
          .querySelector(".page-body-wrapper")
          .classList.add("full-page-wrapper");

        break;
      } else {
        this.setState({ isFullPageLayout: false });
        document
          .querySelector(".page-body-wrapper")
          .classList.remove("full-page-wrapper");
      }
    }
    console.log(location.pathname, this.state.isFullPageLayout);
  }

  render() {
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar /> : "";
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar /> : "";
    let SettingsPanelComponent = !this.state.isFullPageLayout ? (
      <SettingsPanel />
    ) : (
      ""
    );
    let footerComponent = !this.state.isFullPageLayout ? <Footer /> : "";

    return (
      <div className="container-scroller">
        {navbarComponent}
        <div className="container-fluid page-body-wrapper">
          {sidebarComponent}
          <div className="main-panel">
            <div className="content-wrapper">
              <AppRoutes />
              {SettingsPanelComponent}
            </div>
            {footerComponent}
          </div>
        </div>
      </div>
    );
  }
}
// ✅ HOC custom avec i18n
export default withTranslation()(withRouter3(App2));
